import { Breadcrumbs, Typography } from '@mui/material';
import styled from 'styled-components';

import { TScrollFadeMaskProps } from '@/shared/components/ui/scroll-fade/scroll-fade.types';
import { getScrollFadeMask } from '@/shared/components/ui/scroll-fade/scroll-fade.utils';

export const StyledBreadcrumbs = styled(Breadcrumbs)<TScrollFadeMaskProps>`
  && {
    flex-grow: 1;
    /* Without it the trail cannot shrink below its own width and pushes the
       header actions off the bar instead of scrolling. */
    min-width: 0;
    margin-right: 2rem;
    height: ${({ theme }) => theme.spacing(12)};
    display: flex;
    align-items: center;
    /* Scrolls here rather than on the list: the bar is taller than the crumbs,
       so its scrollbar sits below the text instead of across it. */
    overflow-x: auto;
    mask-image: ${getScrollFadeMask};
    -webkit-mask-image: ${getScrollFadeMask};

    /* The whole path is the point, so it stays on one line and scrolls. */
    .MuiBreadcrumbs-ol {
      flex-wrap: nowrap;
    }

    .MuiBreadcrumbs-li > a {
      color: ${({ theme }) => theme.palette.text.primary};
      text-decoration: none;
      ${({ theme }) => theme.typography.button1};
      transition: text-decoration 0.3s ease-in-out;

      &:hover {
        text-decoration: underline;
      }
    }

    .MuiBreadcrumbs-li > p {
      color: ${({ theme }) => theme.palette.text.secondary};
      ${({ theme }) => theme.typography.p7};
    }
  }
`;

export const Separator = styled(Typography)`
  && {
    color: ${({ theme }) => theme.palette.text.primary};
    ${({ theme }) => theme.typography.p6};
  }
`;

export const Breadcrumb = styled(Typography)`
  && {
    cursor: pointer;
    white-space: nowrap;
  }
`;
